import React, { Component } from "react"
import {FaReact, FaHtml5, FaCss3, FaJs, FaBootstrap, FaSass, DiJqueryLogo} from "react-icons/all";


class Skills extends Component {
    state = {
        skills: [
            {
                icon: <FaHtml5 className="icon"/>
            },
            {
                icon: <FaCss3 className="icon"/> 
            },
            {
                icon: <FaJs className="icon"/>
            },
            {
                icon: <FaBootstrap className="icon"/>
            },
            {
                icon: <FaSass className="icon"/>
            },
            {
                icon: <DiJqueryLogo className="icon"/>
            },
            {
                icon: <FaReact className="icon"/>
            }
        ]
    }
    render() {
        return (
            <div id="skills">
                <div className="container">
                    <h1>My Skills</h1>
                    <div className="skills-showcase">
                        {this.state.skills.map((item,index) => {
                            return <article key={index}>
                                    {item.icon}
                                </article>
                            })
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default Skills;